module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_08.b5e61934.jpg";